<template>
    <div class="card card-round shadow dashboard-widget dashboard-widget--boq" >
        <div class="card-header d-flex justify-content-between mb-0">
            <h6 class="mb-0 fw-bold dashboard-widget__title">
                <span class="dashboard-widget__icon" v-html="sidebarSvg.boq"></span>
                <span>{{ $t('Bill of Quantities') }}</span>
            </h6>
        </div>
        <div class="card-body p-0">
            <div class="table-responsive" >
                <table class="table table-striped ">
                    <thead>
                        <tr>
                            <th> {{ $t('Name') }}</th>
                            <th class="text-center"> {{ $t('Total Cost') }}</th>
                            <th class="text-center"> {{ $t('Total Sell') }}</th>
                            <th class="text-center"> {{ $t('GP Total') }}</th>
                            <th class="text-center"> {{ $t('GP') }} %</th>
                            <th> {{ $t('Status') }}</th>
                            <th class="dashboard-widget-table__actions">{{ $t('Actions') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, key) in data.docs" :key="key">
                            <td title="Click to View Items" class="text-capitalize">
                                <a :href="boqUrl + '/boq/builder/' + item._id" class="link-style-custom">  {{item.name}}</a>
                            </td>
                                <template v-if="item.summary">
                                <td class="text-end">{{item.currencyId.sign}}{{ReformatNumber(item.summary.costTotal)}}</td>
                                <td class="text-end">{{item.currencyId.sign}}{{ReformatNumber(item.summary.sellTotal)}}</td>
                                <td class="text-end">{{item.currencyId.sign}}{{ReformatNumber(item.summary.gp)}}</td>
                                <td class="text-end">{{ReformatNumber((item.summary.gp / item.summary.sellTotal) * 100)}}%</td>
                            </template>
                            <template v-else>
                                <td class="text-end">{{item.currencyId.sign}}0.00</td>
                                <td class="text-end">{{item.currencyId.sign}}0.00</td>
                                <td class="text-end">{{item.currencyId.sign}}0.00</td>
                                <td class="text-end">-</td>
                            </template>
                            <td>
                                <span :class="'badge ' + ApprovalStageBoqObj[item.approvalStage -1].color">{{ApprovalStageBoqObj[item.approvalStage-1].name}}</span>
                            </td>
                            <td class="dashboard-widget-table__actions">
                                <a :href="boqUrl + '/boq/builder/' + item._id" :title="$t('View')" :aria-label="$t('View')">
                                    <i class="fa-regular fa-eye" aria-hidden="true"></i>
                                </a>
                            </td>
                        </tr>
                        <tr v-if="data.length==0">
                            <td colspan="7" class="text-center dashboard-widget__empty-state" >
                                {{ $t('No data Found') }}
                            </td>
                        </tr>
                    </tbody>
                    
                </table>
            </div>
            <div class="dashboard-widget__footer"  v-if="data.length!=0">
                
                <a class="btn dashboard-widget__button" 
                data-bs-target="#BoqModalAdd" data-bs-toggle="modal"  @click="()=>{ newBoq={};}"> <i class="fa-solid fa-plus"></i> {{ $t('Add Bill of Quantity') }}</a>
                <a :href="boqUrl + '/boq/' + projectInfo._id" class="dashboard-widget__link"> {{ $t('View All') }}</a>
            </div>
        </div>
    </div>
    
</template>

<script>
import {GetBoqList} from '@/actions/projectActions.js'
import {ReformatNumber, ReformatDate, ApprovalStageBoqObj, ModuleActionList} from '../../helpers/utilities.js'
import { mapGetters } from 'vuex'
import { sidebarSvg } from '@/components/deluxe/DeluxeSidebar.vue'
import 'dotenv/config'
export default {
    name : 'BillOfQuanitityListWidget',
    props : ['projectInfo'],
    data(){
        return {
            data : [],
            ApprovalStageBoqObj,
            newBoq : {},
            boqSaveClicked : false,
            isExecuting : false,
            boqUrl : process.env.VUE_APP_BOQ_URL,
            ModuleActionList,
            quotationList : [],
            sidebarSvg
        }
    },
    mounted : async function(){
        const self = this

        const response = await GetBoqList(self.projectInfo._id , 1,"",5)
        if(!response)
            return
        self.data = response
    },
    methods :{
        ReformatNumber,
        ReformatDate,
        
    },
    computed : {
        ...mapGetters(['permission'])
    }
    
} 
</script>
